document.addEventListener('DOMContentLoaded', () => {
  const select = document.getElementById('my-m-investment-select');
  const btn = document.getElementById('my-m-investment-go');

  select?.addEventListener('change', () => {
    btn.disabled = !select.value;
  });

  btn?.addEventListener('click', () => {
    if (select.value) window.open(select.value, '_blank');
  });
});
